import { useMemo } from "react";
import { useRestrictedWords, useSettingsCache } from "@/shared/cache";
import { resolveMatterScope } from "@/shared/utils/matterScope";
import { SpellcheckedNarrative } from "./SpellcheckedNarrative";

/** Shared by attorney/admin group rows, including streaming narratives. */
export function EntryNarrative({
	matterId,
	client,
	...props
}: {
	text: string;
	matterId?: string | null;
	client?: string | null;
	className?: string;
	debounceMs?: number;
}) {
	const { getRestrictedWords } = useRestrictedWords();
	const { settings } = useSettingsCache();
	const words = useMemo(() => {
		if (!settings.check_for_red_words) return [];
		const scope = resolveMatterScope(matterId, client);
		return getRestrictedWords(scope?.clientCode, scope?.matterId);
	}, [matterId, client, settings.check_for_red_words, getRestrictedWords]);
	return <SpellcheckedNarrative {...props} restrictedWords={words} />;
}
